module.exports = __webpack_public_path__ + "img/Gottesdienst.1fd921b9.jpg";